import React, { type ReactNode } from 'react';

interface PaginationBarProps {
  start?: ReactNode;
  center?: ReactNode;
  end?: ReactNode;
  className?: string;
}

export const PaginationBar: React.FC<PaginationBarProps> = ({
  start,
  center,
  end,
  className = '',
}) => {
  const containerClasses =
    'flex flex-wrap items-center justify-between gap-4 rounded-md bg-white px-4 py-0 min-h-[2.5rem]';

  return (
    <div className={`${containerClasses} ${className}`}>
      {start && <div className="flex items-center gap-4 order-1">{start}</div>}

      {center && (
        <div className="flex-1 flex items-center justify-start min-w-0 order-3 lg:order-2 w-full lg:w-auto basis-full lg:basis-auto">
          {center}
        </div>
      )}

      {end && (
        <div className="flex items-center gap-1 order-2 lg:order-3 ml-auto lg:ml-0">
          {end}
        </div>
      )}
    </div>
  );
};
